// Dependencies
import React from "react";
import { useIntl } from "react-intl";
import { Grid, IconButton } from '@mui/material';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import Typography from '@mui/material/Typography';
// Components
import InputDate from 'Components/InputDate';
import moment from "moment";
import './index.scss';

const CustomTime = (props) => {
    const {
        value,
        day,
        checkOneDay,
        handleTimeChange,
        addDayCallback,
        removeDayCallback,
        validRange,
        overlappingDatesErrorMessage,
        isValidDay,
        invalidDayMessage,
        disableAddChange
    } = props;
    const { messages } = useIntl();




    /**
     * Builds the days right button according the given day.
     * @param {Object} day - The day to show.
     * @returns {React.Node} The built button (add or subtract button).
     */
    const rightButton = (day) => {
        const { parentDay } = day;
        const IconComponent = parentDay ? AddCircleOutlinedIcon : RemoveCircleOutlinedIcon;

        return (
            <IconButton
                aria-label="delete"
                className={'CustomTime-margin'}
                size="small"
                onClick={() => {
                    if (!disableAddChange)
                        return parentDay ? addDayCallback(day) : removeDayCallback(day);
                }}
            >
                <IconComponent fontSize="medium" />
            </IconButton>
        )
    };

    return (
        <Grid
            item
            sm={12}
            style={{borderLeft: (validRange && isValidDay) ? {} : '0.5px red solid',padding: '5px'}}
        >
            <Grid
                container
                className={'CustomTime-dateContainer'}
                justifyContent={'flex-start'}
            >
                <Grid item sm={2}>
                    <div className="form-item">
                        <label className="app-radio-button ">
                            <input
                                type='checkbox'
                                name='type'
                                checked={day.checked}
                                onChange={() => { checkOneDay(value) }}
                            />
                            <div className='app-radio-button-box'>
                                <span className='app-radio-button-box-type pt-2'>{messages[`alertsNewAlert_${day?.label}`]}</span>
                            </div>
                        </label>
                    </div>
                </Grid>
                <Grid item sm={5}>
                    <InputDate
                        id="dateInit"
                        placeholder={messages['vehicleStatusModal_time']}
                        type="time"
                        value={day.timeFrom}
                        onChange={(date) => {
                            handleTimeChange(date, 'timeFrom', value);
                        }}
                        timeIntervals="60"
                        required={day.checked}
                        disabled={!day.checked || disableAddChange}
                        requiredMessage="Required Field"
                        iconType="unfold_more"
                    />
                </Grid>
                <Grid item sm={5}>
                    <InputDate
                        id="dateEnd"
                        placeholder={messages['vehicleStatusModal_time']}
                        type="time"
                        value={day.timeTo}
                        onChange={(date) => {
                            handleTimeChange(date, 'timeTo', value);
                        }}
                        minTime={moment().hours(0).minutes(59).toDate()}
                        maxTime={moment().hours(23).minutes(59).toDate()}
                        timeIntervals="1440"
                        required={day.checked}
                        disabled={!!(!day.checked || !day.timeFrom) || disableAddChange}
                        requiredMessage="Required Field"
                        iconType="unfold_more"
                        injectTimes={[
                            moment().hours(0).minutes(59).toDate(),
                            moment().hours(1).minutes(59).toDate(),
                            moment().hours(2).minutes(59).toDate(),
                            moment().hours(3).minutes(59).toDate(),
                            moment().hours(4).minutes(59).toDate(),
                            moment().hours(5).minutes(59).toDate(),
                            moment().hours(6).minutes(59).toDate(),
                            moment().hours(7).minutes(59).toDate(),
                            moment().hours(8).minutes(59).toDate(),
                            moment().hours(9).minutes(59).toDate(),
                            moment().hours(10).minutes(59).toDate(),
                            moment().hours(11).minutes(59).toDate(),
                            moment().hours(12).minutes(59).toDate(),
                            moment().hours(13).minutes(59).toDate(),
                            moment().hours(14).minutes(59).toDate(),
                            moment().hours(15).minutes(59).toDate(),
                            moment().hours(16).minutes(59).toDate(),
                            moment().hours(17).minutes(59).toDate(),
                            moment().hours(18).minutes(59).toDate(),
                            moment().hours(19).minutes(59).toDate(),
                            moment().hours(20).minutes(59).toDate(),
                            moment().hours(21).minutes(59).toDate(),
                            moment().hours(22).minutes(59).toDate(),
                            moment().hours(23).minutes(59).toDate(),
                        ]}
                    />
                </Grid>
                {rightButton(day)}
            </Grid>
            {!validRange && (
                <Typography variant="caption" display="block" gutterBottom color="error">
                    {overlappingDatesErrorMessage}
                </Typography>
            )}
            {!isValidDay && (
                <Typography variant="caption" display="block" gutterBottom color="error">
                    {invalidDayMessage}
                </Typography>
            )}
        </Grid>
    )
}

export default CustomTime;
